import React from "react";
import ReactDOM from "react-dom/client";
import { ChakraProvider } from "@chakra-ui/react";
import router from "./routes/Router.js";
import { AuthProvider } from "./context/AuthContext";
import theme from "./theme";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ChakraProvider theme={theme}>
    <AuthProvider>{router}</AuthProvider>
  </ChakraProvider>
);
